import React from 'react';
import './HowItWorks.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMobileAlt,
  faSearch,
  faStore,
  faShoppingBag,
} from '@fortawesome/free-solid-svg-icons';

const steps = [
  {
    icon: faMobileAlt,
    title: 'Download App',
    description: 'Install MyApoti from the App Store or Google Play when we launch.',
  },
  {
    icon: faSearch,
    title: 'Search Drug',
    description: 'Find the exact drug you need within seconds.',
  },
  {
    icon: faStore,
    title: 'View Pharmacies',
    description: 'Get a list of nearby verified pharmacies with your drug in stock.',
  },
  {
    icon: faShoppingBag,
    title: 'Visit or Order',
    description: 'Choose to walk in or place an order directly from the app.',
  },
];

const HowItWorks = () => {
  return (
    <section className="how-it-works">
      <h2 className="how-title">How It Works</h2>
      <div className="steps-grid">
        {steps.map((step, index) => (
          <div key={index} className="step-card">
            <div className="step-number">Step {index + 1}</div>
            <FontAwesomeIcon icon={step.icon} className="step-icon" />
            <h3 className="step-title">{step.title}</h3>
            <p className="step-desc">{step.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorks;
